import { NavigationKey } from '@generated/graphql';

/**
 * EC-758: a user may hold the sales and the ticketing shell together, and each of them is a
 * board on its own URL. The search shell is never a board: a search-only bare `/pipeline`
 * composes FlightRequestsModule, and its card deep links redirect to the card's own page.
 */
export type BoardShell = 'sales' | 'ticketing';

export const BOARD_SHELLS: ReadonlyArray<{
  shell: BoardShell;
  navKey: NavigationKey;
  path: string;
  label: string;
}> = [
  {
    shell: 'sales',
    navKey: NavigationKey.PipelineSales,
    path: '/pipeline/sales',
    label: 'Sales Pipeline',
  },
  {
    shell: 'ticketing',
    navKey: NavigationKey.PipelineTicketing,
    path: '/pipeline/ticketing',
    label: 'Ticketing Pipeline',
  },
];

/** The shell keys in the backend's order: the first one held is the default board. */
const SHELL_KEYS = [
  NavigationKey.PipelineSales,
  NavigationKey.PipelineTicketing,
  NavigationKey.PipelineSearch,
];

export const availableBoards = (keys: NavigationKey[]): (typeof BOARD_SHELLS)[number][] =>
  BOARD_SHELLS.filter((board) => keys.includes(board.navKey));

// Sales when a key set somehow carries no shell: the route is only reached with the PIPELINE
// key, which the backend never sends without one.
export const defaultShellKey = (keys: NavigationKey[]): NavigationKey =>
  SHELL_KEYS.find((key) => keys.includes(key)) ?? NavigationKey.PipelineSales;
